import Stores from 'config/Stores';
import { observable, action, computed, flow } from 'mobx';
import Config from 'config/Config';
// 从v2.11.2起，SDK 支持了 WebSocket，推荐接入；v2.10.2及以下版本，使用 HTTP
import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
import { emojiName, emojiUrl, emojiMap } from './emojiMap';
import Util from 'utils';
console.log('Util', Util);

class TimMobx {
  @observable tim = null; // 实例化后
  @observable timSDK = null; // TIMSDK
  @observable timIsLogin = false; // 是否登录成功
  @observable timSdkReady = false; // IM加载状态
  @observable chatList = []; // 会话列表
  @observable newMessageList = []; // 收到消息列表
  @observable messageList = []; // 某个会话消息列表
  @observable emojiList = []; // 表情列表
  @observable nextReqMessageID = ''; // 用于续拉，分页续拉时需传入该字段。
  @observable isCompleted = ''; // 表示是否已经拉完所有消息。isCompleted 为 true 时，nextReqMessageID 为 ""。
  @observable isLoading = false; // 会话页面刷新状态
  @observable chatId = null; // 会话ID
  @observable chatNick = null; // 会话昵称

  @observable onSdkReady = false; // IM加载状态
  @observable timLoginState = false; // 登录状态
  @observable timLoginProgress = 0; // 0 正常，1进行中,2登录成功，3登录失败
  @action
  setVal(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
  @action
  clearData() {
    this.chatList = [];
    this.messageList = [];
    this.newMessageList = [];
  }

  // 初始化
  init = flow(function* () {
    try {
      return false;
      let appid = 1400732504; // 1400398791生产，测试1400732504
      if (Config.HOST == 'PROD' || Config.HOST == 'GREEN' || Config.HOST == 'BLUE') {
        appid = 1400398791; // 生产
      }
      this.destroy();
      this.timSDK = TIM;
      let options = {
        SDKAppID: appid // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
      };
      // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
      this.tim = TIM.create(options); // SDK 实例通常用 tim 表示
      // alert(JSON.stringify(this.tim))
      // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel  https://web.sdk.qcloud.com/im/doc/zh-cn/SDK.html#setLogLevel 接口的说明</a>
      //   timMobx.tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
      this.tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
      // 监听事件
      this.timeON();
      // 注册腾讯云即时通信 IM 上传插件
      this.tim.registerPlugin({
        'tim-upload-plugin': TIMUploadPlugin
      });

      this.setEmojiData();
      // this.timLogin()
    } catch (error) {}
  });

  // 设置表情
  setEmojiData = flow(function* () {
    let list = [];
    for (let i = 0; i < emojiName.length; i++) {
      list.push({
        emojiName: emojiName[i],
        url: emojiUrl + emojiMap[emojiName[i]]
      });
    }
    // console.log('listlist', list)
    this.emojiList = list;
  });

  // 监听事件
  timeON = flow(function* () {
    let tim = this.tim;
    // SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能
    let onSdkReady = (event) => {
      let userInfo = Util.getLocalCache('member_userInfo');

      console.log('SDK 进入 ready 状态', userInfo);
      this.setVal({
        timSdkReady: true
      });

      if (userInfo) {
        console.log('更新头像', userInfo);
        this.setUpdateMyProfile({
          nick: userInfo.realName || '', // 昵称
          avatar: userInfo.avatar || '' // 头像
        });
      }
    };

    this.tim.on(TIM.EVENT.SDK_READY, onSdkReady);

    // SDK 进入 not ready 状态时触发，此时接入侧将无法使用 SDK 发送消息等功能。如果想恢复使用，接入侧需调用 login 接口，驱动 SDK 进入 ready 状态
    let onSdkNotReady = (event) => {
      console.log('初始化');
      // 如果想使用发送消息等功能，接入侧需驱动 SDK 进入 ready 状态，重新调用 login 接口即可，如下所示：
    };
    this.tim.on(TIM.EVENT.SDK_NOT_READY, onSdkNotReady);
    // SDK 收到推送的单聊、群聊、群提示、群系统通知的新消息，接入侧可通过遍历 event.data 获取消息列表数据并渲染到页面
    let onMessageReceived = async (event) => {
      console.log('收到消息', event.data);
      let list = [];
      const messageList = event.data;

      this.setVal({
        newMessageList: messageList || []
      });

      messageList.forEach((message) => {
        if (message.type === TIM.TYPES.MSG_TEXT) {
          // 文本消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.TextPayload
        } else if (message.type === TIM.TYPES.MSG_IMAGE) {
          // 图片消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.ImagePayload
        } else if (message.type === TIM.TYPES.MSG_SOUND) {
          // 音频消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.AudioPayload
        } else if (message.type === TIM.TYPES.MSG_VIDEO) {
          // 视频消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.VideoPayload
        } else if (message.type === TIM.TYPES.MSG_FILE) {
          // 文件消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.FilePayload
        } else if (message.type === TIM.TYPES.MSG_CUSTOM) {
          // 自定义消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.CustomPayload
        } else if (message.type === TIM.TYPES.MSG_MERGER) {
          // 合并消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.MergerPayload
        } else if (message.type === TIM.TYPES.MSG_LOCATION) {
          // 地理位置消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.LocationPayload
        } else if (message.type === TIM.TYPES.MSG_GRP_TIP) {
          // 群提示消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.GroupTipPayload
        } else if (message.type === TIM.TYPES.MSG_GRP_SYS_NOTICE) {
          // 群系统通知 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.GroupSystemNoticePayload
        }
      });
    };
    this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);

    // SDK 收到对端已读消息的通知，即已读回执。可通过遍历 event.data 获取对端已读的消息列表数据并渲染到页面，如单聊会话内可将己方发送的消息由“未读”状态改为“已读”。
    //   let onMessageReadByPeer = function (event) {
    //     // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isPeerRead 属性值为 true
    //   };
    //   timMobx.tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, onMessageReadByPeer);
    // 会话列表更新，event.data 是包含 Conversation 对象的数组
    let onConversationListUpdated = (event) => {
      console.log('会话列表', event.data); // 包含 Conversation 实例的数组
      this.setVal({
        chatList: []
      });
      this.setVal({
        chatList: event.data || []
      });
    };
    this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, onConversationListUpdated);
    // 创建话题时触发（v2.19.1起支持）
    //   let onTopicCreated = function (event) {
    //     const groupID = event.data.groupID // 话题所属社群 ID
    //     const topicID = event.data.topicID // 话题 ID
    //     console.log(event.data);
    //   };
    //   timMobx.tim.on(TIM.EVENT.TOPIC_CREATED, onTopicCreated);

    // 删除话题时触发（v2.19.1起支持）
    let onTopicDeleted = function (event) {
      const groupID = event.data.groupID; // 话题所属社群 ID
      const topicIDList = event.data.topicIDList; // 删除的话题 ID 列表
      console.log(event.data);
    };
    this.tim.on(TIM.EVENT.TOPIC_DELETED, onTopicDeleted);
    // 话题资料更新时触发（v2.19.1起支持）
    //   let onTopicUpdated = function (event) {
    //     const groupID = event.data.groupID // 话题所属社群 ID
    //     const topic = event.data.topic // 话题资料
    //     console.log(event.data);
    //   };
    //   timMobx.tim.on(TIM.EVENT.TOPIC_UPDATED, onTopicUpdated);
    // 自己或好友的资料发生变更时触发，event.data 是包含 Profile 对象的数组
    //   let onProfileUpdated = function (event) {
    //     console.log(event.data); // 包含 Profile 对象的数组
    //   };
    //   timMobx.tim.on(TIM.EVENT.PROFILE_UPDATED, onProfileUpdated);

    // SDK 黑名单列表更新时触发
    let onBlacklistUpdated = function (event) {
      console.log(event.data); // 我的黑名单列表，结构为包含用户 userID 的数组
    };
    this.tim.on(TIM.EVENT.BLACKLIST_UPDATED, onBlacklistUpdated);
    // 好友列表更新时触发
    //   let onFriendListUpdated = function (event) {
    //     console.log(event.data);
    //   }
    //   tim.on(TIM.EVENT.FRIEND_LIST_UPDATED, onFriendListUpdated);

    // 好友分组列表更新时触发
    let onFriendGroupListUpdated = function (event) {
      console.log(event.data);
    };
    this.tim.on(TIM.EVENT.FRIEND_GROUP_LIST_UPDATED, onFriendGroupListUpdated);

    // 用户被踢下线时触发
    let onKickedOut = function (event) {
      console.log(event.data.type);
      // TIM.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一帐号，多页面登录被踢)
      // TIM.TYPES.KICKED_OUT_MULT_DEVICE(同一帐号，多端登录被踢)
      // TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期)
      // TIM.TYPES.KICKED_OUT_REST_API(REST API kick 接口踢出。v2.20.0起支持)
    };
    this.tim.on(TIM.EVENT.KICKED_OUT, onKickedOut);

    // 网络状态发生改变
    //   let onNetStateChange = function (event) {
    //     // v2.5.0 起支持
    //     // event.data.state 当前网络状态，枚举值及说明如下：
    //     // TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
    //     // TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
    //     // TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    //   };
    //   timMobx.tim.on(TIM.EVENT.NET_STATE_CHANGE, onNetStateChange);
  });

  // 消息发送
  sendMessage = flow(async function* (params, cloudCustomData = '') {
    let message = this.tim.createTextMessage({
      to: params.userId,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: {
        text: params.content || ''
      },
      // v2.20.0起支持C2C消息已读回执功能，如果您发消息需要已读回执，需购买旗舰版套餐，并且创建消息时将 needReadReceipt 设置为 true
      needReadReceipt: true,
      // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
      cloudCustomData: JSON.stringify(cloudCustomData) || ''
    });
    const imResponse = await this.tim.sendMessage(message);
    return imResponse;
  });

  // 获取会话列表
  getConversationList = flow(function* () {
    // this.setVal({
    //   chatList: []
    // })
    this.tim
      .getConversationList()
      .then((imResponse) => {
        const conversationList = imResponse.data.conversationList; // 全量的会话列表，用该列表覆盖原有的会话列表
        console.log('聊天列表', conversationList);

        this.setVal({
          chatList: conversationList || []
        });
        return conversationList;
      })
      .catch(function (imError) {
        console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
        return [];
      });
  });

  // 获取某个会话消息列表
  getMessageList = flow(async function* (id, nID = '', pageNum = 1) {
    // 下拉查看更多消息
    let params = {
      conversationID: `C2C${id}`,
      nextReqMessageID: nID,
      count: 15
    };

    if (!nID || nID == '') {
      delete params.nextReqMessageID;
    }
    console.log('params', params);
    let imResponse = await this.tim.getMessageList(params);
    console.log('imResponse.data', imResponse);
    if (imResponse && imResponse.data) {
      const messageList = imResponse.data.messageList; // 消息列表。
      const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
      const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。isCompleted 为 true 时，nextReqMessageID 为 ""。

      let list = nID ? [...messageList, ...this.messageList] : messageList;

      this.setVal({
        messageList: list,
        nextReqMessageID,
        isCompleted
      });
      return true;
    } else {
      return false;
    }
  });

  // 获取用户资料
  getUserProfile = flow(async function* (cid) {
    const result = await this.tim.getUserProfile({
      userIDList: [cid]
    });
    return result;
  });

  // 消息设置已读
  setMessageRead = flow(function* (id) {
    // 将某会话下所有未读消息已读上报
    let promise = this.tim.setMessageRead({
      conversationID: `C2C${id}`
    });
    promise
      .then((imResponse) => {
        // 已读上报成功，指定 ID 的会话的 unreadCount 属性值被置为0
        return true;
      })
      .catch(function (imError) {
        // 已读上报失败
        console.warn('setMessageRead error:', imError);
        return false;
      });
  });

  // 登录
  timLogin = flow(async function* (params) {
    let _this = this;
    const timLoginStatus = Util.getLocalCache('timLoginStatus') || false;
    if (timLoginStatus || this.timLoginProgress == 2) {
      // await this.destroy() // 登录状态先退出账号
    }
    this.setVal({
      timLoginProgress: 1
    });
    this.tim
      .login({
        userID: (params.userId && params.userId.toString()) || '',
        userSig: params.userSig || ''
      })
      .then((imResponse) => {
        console.log('lgoin', imResponse.data); // 登录成功
        if (imResponse.data.repeatLogin === true) {
          // 标识帐号已登录，本次登录操作为重复登录。v2.5.1 起支持
          console.log('标识帐号已登录', imResponse.data.errorInfo);
          this.setVal({
            timLoginProgress: 3
          });
        } else {
          console.log('IM登录成功');
          this.setVal({
            timIsLogin: false,
            timLoginProgress: 2
          });
          Util.setLocalCache('timLoginStatus', true); // 登录状态存缓存
        }
      })
      .catch((imError) => {
        this.setVal({
          timIsLogin: false,
          timLoginProgress: 3
        });
        console.warn('login IM登录失败:', imError); // 登录失败的相关信息
      });
  });

  // 设置用户资料
  setUpdateMyProfile = flow((params) => {
    console.log(params);
    if (params) {
      this.tim.updateMyProfile(params).then((res) => {
        if (res.code == 0) {
          console.log('更新资料成功', res);
          this.setVal({
            timSdkReady: true
          });
        }
      });
    }
  });

  // 查询用户状态
  getUserStatus = flow((list) => {
    return new Promise((resolve, reject) => {
      let promise = this.tim.getUserStatus({ userIDList: list });
      promise
        .then((imResponse) => {
          const { successUserList } = imResponse.data;
          successUserList.forEach((item) => {
            const { userID, statusType, customStatus } = item;
            // userID - 用户 ID
            // statusType - 用户状态，枚举值及说明如下：
            // TIM.TYPES.USER_STATUS_UNKNOWN - 未知
            // TIM.TYPES.USER_STATUS_ONLINE - 在线
            // TIM.TYPES.USER_STATUS_OFFLINE - 离线
            // TIM.TYPES.USER_STATUS_UNLOGINED - 未登录
            // customStatus - 用户自定义状态
          });
          resolve(successUserList[0]);
        })
        .catch(function (imError) {
          console.warn('getUserStatus error:', imError); // 获取用户状态失败的相关信息
          reject(imError);
        });
    });
  });

  // 退出并销毁 SDK 实例
  destroy = flow(function* () {
    return new Promise((resolve, reject) => {
      if (this.tim) {
        this.tim
          .logout()
          .then((res) => {
            this.setVal({
              timIsLogin: false
            });
            console.log('IM退出登录成功');
            resolve();
          })
          .catch((err) => {
            console.log('IM退出失败', err);
            reject();
          });

        // this.tim.destroy();
      }
    });
  });

  // 表情显示
  renderEmoji = flow(function* (emoji) {
    return;
  });
}

const timMobx = new TimMobx();
export default timMobx;



// WEBPACK FOOTER //
// ./src/pages/TIM/Common/tim.js